import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useSWR from 'swr';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LazyLoad from 'react-lazyload';

import ImageCard from './ImageCard';
import { getTranslation } from '../utils/translate';
import { getBeefProductOverride } from '../utils/overrides';
import Loader from './Loader';

const BeefCutsGrid = ({ payload, language }) => {
  const retailer = useSelector(state => state.retailer);
  const { data, isLoading } = useSWR(payload);

  return (
    <Grid container spacing={2}>
      {isLoading && (
        <Grid item xs={12}>
          <Loader />
        </Grid>
      )}
      {data?.data?.map((beefCut) => {
        const beefOverride = getBeefProductOverride(beefCut, retailer, { code: language.code });
        const translatedOverride = getTranslation(beefOverride, { key: 'languages_code', code: language.code });
        const translatedBeefCut = getTranslation(beefCut, { key: 'languages_id', code: language.code }, 'translations');
        const title = translatedOverride?.name || translatedBeefCut?.name;
        const description = translatedOverride?.description || translatedBeefCut?.description;
        const imageUrl = beefCut?.image ? `${process.env.REACT_APP_API_URL}/assets/${beefCut.image}` : '';

        return (
          <Grid
            key={beefCut.id}
            item
            xs={12}
            sm={4}
            md={4}
            lg={3}
            xl={2}
          >
            <Box sx={{ height: '100%' }}>
              <LazyLoad height='100%'>
                <ImageCard
                  description={description}
                  url={`/beef-cuts/${beefCut.id}`}
                  item={{
                    title,
                    description,
                    url: imageUrl
                  }}
                  footerAction={<Box sx={{ my: 0.5 }} />}
                />
              </LazyLoad>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

BeefCutsGrid.propTypes = {
  payload: PropTypes.object.isRequired,
  language: PropTypes.shape({ code: PropTypes.string.isRequired }).isRequired,
};

export default BeefCutsGrid;


